module.exports = __webpack_public_path__ + "static/media/21_1.bf57923b.png";